export default __webpack_public_path__ + "static/media/gold_medal.8174f8b7.svg";